import {
	FileImageOutlined,
	FormOutlined,
	PlusCircleFilled,
	DeleteOutlined,
	// FormOutlined,
	// PlusCircleFilled,
} from "@ant-design/icons";
import { Form, Input, Modal, Switch, Select, Space } from "antd";
import BlockLinkItem from "components/BlockLinkItem";
import { SingleImageUpload } from "components/SingleImageUpload";
import React, { useEffect, useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import { api } from "services/api";
import Swal from "sweetalert2";
import { IBlock } from "types";
// import { IAddClasses } from "types";
import { getBase64Img } from "utils";

const { Option } = Select;

export const EditClassModal: React.FC<any> = ({ ...props }) => {
	const [option, setOption] = useState<string>("");
	const [classStatus, setClassStatus] = useState<boolean>(false);
	const [isActive, setIsActive] = useState<boolean>(false);
	const [imageWasEdited, setImageWasEdited] = useState<boolean>(false);
	const [isPay, setIsPay] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(false);
	const {
		form,
		blocks,
		isOpen,
		setCurrentImgURL,
		setIsOpen,
		currentImgURL,
		setCourseStatus,
		setIsOpenBlock,
		setEditMode,
		setSelectedBlockId,
		setIsOpenEditBlock,
		isOpenEditBlock,
		currentClassInfo,
		setBlocks,
		setProcessing,
		courseId: moduleId,
		editMode,
		titlePage,
		onUpdated
	} = props;

	const handleRegister = (values: any) => {
		setProcessing(true);
		api
			.put(`/classes/${currentClassInfo?.id}`, values)
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;
					onUpdated(result.data)
					setProcessing(false);
					Swal.fire({
						icon: "success",
						text: feedback["success"],
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						setIsOpen(false);
						form.resetFields();
						setCurrentImgURL("");
						setCourseStatus(false);
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};

	const handleDeleteBlock = (blockId: string) => {
		setProcessing(true);
		api
			.delete(`/blocks/${blockId}`)
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;

					setProcessing(false);

					Swal.fire({
						icon: "success",
						text: feedback["success"],
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						handleLoadBlocks(currentClassInfo?.id);
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};

	const handleLoadBlocks = (classId: string) => {
		setLoading(true);
		setTimeout(async () => {
			await api.get(`/blocks/classes/${classId}/content`).then((result) => {
				if ([200, 201].includes(result.status)) {
					setBlocks([]);
					setBlocks(result.data.data.blockes);
					setLoading(false);
				}
			});
		}, 500);
	};

	useEffect(() => {
		if (isOpen) {
			form.setFieldsValue({
				title: currentClassInfo?.title,
				description: currentClassInfo?.description,
				visibility:
					currentClassInfo?.visibility === "public" ? "public" : "private",
			});
			setOption(
				currentClassInfo?.visibility === "public" ? "public" : "private"
			);
			setClassStatus(currentClassInfo?.status === "publish" ? true : false);
			setIsPay(currentClassInfo?.payment_required === "pay" ? true : false);
			setIsActive(currentClassInfo?.is_active === true ? true : false);
			if (currentClassInfo?.id) {
				handleLoadBlocks(currentClassInfo?.id);
			}
		} else {
			form.resetFields();
			setBlocks([]);
		}
		// eslint-disable-next-line
	}, [isOpen, currentClassInfo]);

	useEffect(() => {
		if (currentClassInfo?.id && !editMode) {
			handleLoadBlocks(currentClassInfo?.id);
		}
		// eslint-disable-next-line
	}, [isOpenEditBlock]);

	const handleChangeImage = (imageUrl: string) => {
		setImageWasEdited(true)
		setCurrentImgURL(imageUrl)
	} 

	return (
		<Modal
			title={<p style={{ margin: 0 }}>{titlePage} - Editar aula</p>}
			open={isOpen}
			maskClosable={false}
			okText="Editar aula"
			cancelText="Cancelar"
			onOk={() => {
				form
					.validateFields()
					.then((values: any) => {
						const allValues = imageWasEdited
							? {
									...values,
									status: classStatus ? "publish" : "pending",
									image: currentImgURL,
									visibility: option,
									is_active: isActive,
									payment_required: isPay ? "pay" : "free",
									order: "2",
									id_module: `${moduleId}`,
							  }
							: {
									...values,
									status: classStatus ? "publish" : "pending",
									visibility: option,
									is_active: isActive,
									payment_required: isPay ? "pay" : "free",
									order: "2",
									id_module: `${moduleId}`,
							  };
						handleRegister(allValues);
					})
					.catch((info: any) => {});
			}}
			onCancel={() => {
				setIsOpen(!isOpen);
				setCurrentImgURL("");
				form.resetFields();
			}}
			width={700}
		>
			<Form form={form} name="new-course" autoComplete="off" layout="vertical">
				<div className="row row-cols-1 row-cols-md-2 justify-content-center align-items-center pe-0">
					<SingleImageUpload showImgURL={currentImgURL?? undefined} onChange={handleChangeImage}/>

					<div className="mt-2">
						<Form.Item
							label="Título"
							name="title"
							rules={[
								{
									required: true,
									message: "Título necessário",
								},
							]}
						>
							<Input placeholder="Título do aula" />
						</Form.Item>
						<Form.Item
							label="Descrição"
							name="description"
							rules={[
								{
									required: true,
									message: "Descrição necessária",
								},
							]}
						>
							<Input placeholder="Descrição da aula" />
						</Form.Item>
					</div>
				</div>

				<div className="row">
					<div className="col-12 col-md-5">
						<Form.Item
							label="Visibilidade"
							name="visibility"
							rules={[
								{
									required: true,
									message: "Visibilidade necessária",
								},
							]}
						>
							<Select
								placeholder="Visibilidade"
								className="m-classes-modal__select"
								value={option}
								onChange={(e) => setOption(e)}
							>
								<Option value="public">Público</Option>
								<Option value="private">Privado</Option>
							</Select>
						</Form.Item>
					</div>
					<div className="col-12 col-md-7 row row-cols-3 pb-3 align-items-center text-center">
						<div>
							<p>Publicado</p>
							<Switch
								checked={classStatus}
								onClick={(e) => setClassStatus(e)}
							/>
						</div>
						<div>
							<p>Pago</p>
							<Switch checked={isPay} onClick={(e) => setIsPay(e)} />
						</div>
						<div>
							<p>Ativo</p>
							<Switch
								checked={isActive}
								onClick={(e) => setIsActive(e)}
							/>
						</div>
					</div>
				</div>

				<div className="m-classes-modal__blocks-content">
					<button type="button" onClick={() => setIsOpenBlock(true)} className="mt-4">
						<PlusCircleFilled /> Inserir Bloco
					</button>

					<div
						className="m-classes-modal__login-info"
						style={{
							minHeight: "300px",
							overflow: "auto",
						}}
					>
						{loading ? (
							<div style={{ margin: "10px 10px" }}>
								<ThreeDots
									height="80"
									width="80"
									radius="9"
									color="#63b8cd"
									ariaLabel="three-dots-loading"
									wrapperStyle={{}}
									visible={true}
								/>
							</div>
						) : (
							<>
								{blocks.length === 0 && (
									<p
										style={{
											height: "100%",
											width: "100%",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
										}}
									>
										Adicione um bloco para visualizar seus respectivos items.
									</p>
								)}
								{blocks.map((block: IBlock, index: any) => {
									const label =
										block.type === "text"
											? "Textual"
											: block.type === "image"
											? "mídia - Imagem"
											: block.type === "youtube"
											? "vídeo - Youtube"
											: block.type === "vimeo"
											? "vídeo - Vimeo"
											: "mídia - Arquivo";
									return (
										<div
											key={index}
											className="m-classes-modal__blocks-content__item mt-4"
										>
											<div
												style={{
													display: "flex",
													justifyContent: "space-between",
												}}
											>
												<p>
													Bloco {label} - Ordem {block.order}
												</p>
												<div className="m-classes-modal__blocks-content__item__btns">
													<Space size="small">
														<FormOutlined
															className="edit"
															onClick={() => {
																setSelectedBlockId(index);
																setEditMode(true);
																setIsOpenEditBlock(true);
															}}
														/>
													</Space>
													<Space size="small" style={{ marginLeft: "10px" }}>
														<DeleteOutlined
															className="edit"
															style={{ color: "red" }}
															onClick={() => {
																handleDeleteBlock(block.id);
															}}
														/>
													</Space>
												</div>
											</div>
											<div className="m-classes-modal__blocks-content__item__content">
												{block.type === "text" && (
													<div
														dangerouslySetInnerHTML={{
															__html: block.content,
														}}
													></div>
												)}
												{block.type === "image" && (
													<img
														src={block.content}
														alt=""
														width="60%"
														height="100%"
													/>
												)}
												{block.type === "youtube" && (
													<BlockLinkItem block={block} />
												)}
												{block.type === "vimeo" && (
													<BlockLinkItem block={block} />
												)}
												{block.type === "archive" && (
													<BlockLinkItem block={block} file={true} />
												)}
											</div>
										</div>
									);
								})}
							</>
						)}
					</div>
				</div>
			</Form>
		</Modal>
	);
};
